import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Modal, List, Button } from 'semantic-ui-react'
import _ from 'lodash'

import { widgetChangePrivacy, widgetModalChangePrivacy, changePublicationScopeWidget } from '_actions/widgets'
import MydClassrooms from 'react-components/myd-classrooms'
import {
  PUBLICATION_SCOPE_OPTIONS,
  PUBLICATION_SCOPE_TREENODE,
} from '_reducers/widgets'
import _t from 'utils/i18n_helper'


const _ListScopes = props => {
  const { widgetPrivacy, auth, onChange } = props
  const treeNodes = {
    ...widgetPrivacy.treeNodes,
    data: [
      {
        id: 'my-classgroups',
        name: _t('ALL-MY-CLASSGROUPS-PLACEHOLDER', true),
        isLeaf: true,
        parentId: _.chain(auth.treeNodes.data).find({parentId: 0}).get('id', 0).value(),
      },
      ...auth.treeNodes.data,
    ]
  }

  return (
    <List selection divided>
      {
        _.map(
          PUBLICATION_SCOPE_OPTIONS,
          item => {
            return (
              <>
                <List.Item
                  active={ widgetPrivacy.publicationScope === item.key }
                  onClick={ () => onChange(item.key, widgetPrivacy.treeNodes) }
                  key={ item.key }
                >
                  <List.Icon name={ item.icon } />
                  <List.Content style={{width: '100%'}}>
                    { _t(item.i18n) }
                  </List.Content>
                </List.Item>
                {
                  item.key === PUBLICATION_SCOPE_TREENODE &&
                  widgetPrivacy.publicationScope === item.key &&
                  <List.Item>
                    <List.Content>
                      {
                        item.key === PUBLICATION_SCOPE_TREENODE &&
                        widgetPrivacy.publicationScope === item.key &&
                        <MydClassrooms
                          treeNodes={ treeNodes }
                          isLoading={ auth.treeNodes.isFetching }
                          onChange={ (e, v) => {
                            let newTree = [
                              ...widgetPrivacy.treeNodes,
                            ]

                            if (_.includes(widgetPrivacy.treeNodes, v.value)) {
                              newTree = _.without(newTree, v.value)
                            } else {
                              newTree = [
                                ...newTree,
                                v.value,
                              ]
                            }
                            onChange(item.key, newTree)
                          }}
                          selected={ widgetPrivacy.treeNodes }
                          multiple={ true }
                        />
                      }
                    </List.Content>
                  </List.Item>
                }
              </>
            )
          }
        )
      }
    </List>
  )
}


export const ListScopes = connect(
  store => ({
    auth: store.auth,
    widgetPrivacy: store.widgetPrivacy,
  })
)(_ListScopes)


const ModalPrivacy = props => {
  const { widgetPrivacy, onSave, onCancel } = props

  const close = () => {
    props.widgetModalChangePrivacy(null, null, null, false)
  }

  const _onCancel = () => {
    if (_.isFunction(onCancel))
      onCancel()

    close()
  }

  const _onSave = () => {
    if (_.isFunction(onSave))
      onSave(widgetPrivacy)

    props.changePublicationScopeWidget(
      widgetPrivacy.widgetId,
      widgetPrivacy.publicationScope,
      widgetPrivacy.treeNodes
    ).then(
      widget => {
        close()
      }
    )
  }

  const onChange = (item, treeNodes) => {
    props.widgetChangePrivacy(item, treeNodes)
  }

  return (
    <Modal close open={ widgetPrivacy.open } size='mini' dimmer='inverted'>
      <Modal.Header>{_t('WIDGET-PRIVACY-LABEL')}</Modal.Header>
      <Modal.Content>
        <Modal.Description>
          <ListScopes onChange={onChange} />
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Button
          loading={ widgetPrivacy.isSaving === true }
          disabled={ widgetPrivacy.isSaving === true }
          primary
          onClick={ _onSave }
        >{_t('GENERIC-LABEL-BUTTON-SAVE')}</Button>
        <Button
          floated='left'
          disabled={ widgetPrivacy.isSaving === true }
          onClick={ _onCancel }
        >{_t('GENERIC-LABEL-BUTTON-CANCEL')}</Button>
      </Modal.Actions>
    </Modal>
  )
}

export default connect(
  store => ({
    widgetPrivacy: store.widgetPrivacy,
  }),
  dispatch => ({
    widgetChangePrivacy: bindActionCreators(widgetChangePrivacy, dispatch),
    widgetModalChangePrivacy: bindActionCreators(widgetModalChangePrivacy, dispatch),
    changePublicationScopeWidget: bindActionCreators(changePublicationScopeWidget, dispatch),
  })
)(ModalPrivacy)
